export default "__VITE_ASSET__fed43e64__"